import { useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { AutoCompleteSelectUI, DeleteDialogUI, FileTabUI, TabsUI } from '../Interface';
import { useFormikContext } from 'formik';
import useParam from '../../context/ParamContext';

const BatchSnTabs = (props) => {
  const { disabled, supportingDocumentTypeOptions } = props;
  const { setFieldValue, values } = useFormikContext();
  const { params } = useParam();
  const [activeTab, setActiveTab] = useState(0);
  const [deleteDialog, setDeletDialog] = useState(false);
  const [fileToDelete, setFileToDelete] = useState(null);

  const handleUpload = (files) => {
    const filesWithId = files.map((file) => {
      file.id = uuidv4();
      file.supportingDocumentTypeId = null;
      return file;
    });

    const existingAttachments = Array.isArray(values.batchSnAttachment) ? values.batchSnAttachment : [];

    setFieldValue('batchSnAttachment', [...existingAttachments, ...filesWithId]);
  };

  const handleSupportingDocumentTypeChange = (row, supportingDocumentTypeId) => {
    setFieldValue(
      'batchSnAttachment',
      (values.batchSnAttachment || []).map((attachment) => {
        if (attachment.id !== row.id) return attachment;

        if (attachment instanceof File) {
          attachment.supportingDocumentTypeId = supportingDocumentTypeId;
          return attachment;
        }

        return {
          ...attachment,
          supportingDocumentTypeId,
        };
      })
    );
  };

  const hideDeleteDialog = () => {
    setDeletDialog(false);
  };

  const handleRemoveElement = () => {
    setFieldValue(
      'batchSnAttachment',
      (values.batchSnAttachment || []).filter((batchSnAttachment) => batchSnAttachment.id !== fileToDelete.id)
    );

    setFileToDelete(null);
    hideDeleteDialog();
  };

  const tabs = [
    {
      id: 1,
      name: 'Csatolmányok',
      content: (
        <FileTabUI
          savedFiles={values?.batchSnAttachment ?? []}
          handleDelete={(file) => {
            setFileToDelete(file);
            setDeletDialog(true);
          }}
          disabled={disabled}
          handleUpload={handleUpload}
          additionalColumns={
            params?.ENABLE_SUPPORTING_DOC === 'Y'
              ? [
                  {
                    field: 'supportingDocumentTypeId',
                    headerName: 'Kísérő dokumentum típus',
                    flex: 0.8,
                    sortable: false,
                    renderCell: (params) => (
                      <div className="w-full" onClick={(event) => event.stopPropagation()}>
                        <AutoCompleteSelectUI
                          id={`supportingDocumentTypeId-${params.row.id}`}
                          dataset={supportingDocumentTypeOptions}
                          selectedValue={params.row.supportingDocumentTypeId}
                          selectedLabelValue={params.row.supportingDocumentType?.name}
                          disabled={disabled}
                          onChange={(_event, value) =>
                            handleSupportingDocumentTypeChange(params.row, value?.value ?? null)
                          }
                        />
                      </div>
                    ),
                  },
                ]
              : []
          }
        />
      ),
    },
  ];

  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
  };

  return (
    <div className="my-4 mt-6">
      <div className="px-3">
        <TabsUI activeTab={activeTab} handleTabClick={handleTabClick}>
          {tabs.map((tab, index) => (
            <div key={index} name={tab.name}>
              {tab.content}
            </div>
          ))}
        </TabsUI>
      </div>
      <DeleteDialogUI
        handleRemoveElement={handleRemoveElement}
        show={deleteDialog}
        onHide={() => {
          hideDeleteDialog();
          setFileToDelete(null);
        }}
      />
    </div>
  );
};

export default BatchSnTabs;
